import { Industries } from "src/constants/constants";

import emergencyAlerts from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/education/Education - Emergency Alerts.png";
import employeeRecognition from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/education/Education - Employee Recognition.png";
import eventPromotion from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/education/Education - Event promotion.png";
import wayfinding from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/education/Education - Wayfinding.png";
import menu from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/education/Education - Menu.png";

import hospitalityMenu from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/hospitality/Hospitality - Menu.png";
import hospitalityEventPromotion from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/hospitality/Hospitality - Event Promotion.png";
import hospitalityWayfinding from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/hospitality/Hospitality - Way Finding.png";
import hospitalitySelfCheckIn from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/hospitality/Hospitality - Self Check-in.png";

import manufacturingEmergencyAlerts from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/manufacturing/Manufacturing - Emergency Alert.png";
import manufacturingBenefits from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/manufacturing/Manufacturing - Employee Benefits.png";
import manufacturingHealthAndSafety from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/manufacturing/Manufacturing - Health & Safety.png";
import manufacturingEmployeeTraining from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/manufacturing/Manufacturing - Employee Training.png";
import manufacturingEventBenefits from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/manufacturing/Manufacturing - Event Benefits.png";
import manufacturingEmployeeRecognition from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/manufacturing/Manufacturing - Employee Recognition.png";

import technologyMeetingRoomAvailability from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/softwareAndService/Technology & B2B -  Meeting Room Availability.png";
import technologyWelcome from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/softwareAndService/Technology & B2B - welcome.png";
import technologyCorporateBrandingAndCulture from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/softwareAndService/Technology & B2B - Corporate Branding and Culture.png";
import technologyEmployeeRecognition from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/softwareAndService/Technology & B2B - Employee Recognition.png";
import technologyInternalComms from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/softwareAndService/Technology & B2B - Training.png";

import retailAd from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/retail/Retail - Ad.png";
import retailEmployeeBenefits from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/retail/Retail - Employee Benifits.png";
import retailEmployeeEngagement from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/retail/Retail - Employee Engagement.png";
import retailEvent from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/retail/Retail - Event.png";
import retailHealthAndSafety from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/retail/Retail - Health and Safety.png";
import retailShiftScheduling from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/retail/Retail - Shift Scheduling.png";

import otherAd from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/other/Other - Advertisement.png";
import otherEmployeeRecognition from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/other/Other - Employee Recognition.png";
import otherEventAnnouncement from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/other/Other - Event Announcement.png";
import otherWelcome from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/other/Other - Welcome Message.png";
import otherHealthAndSafety from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/other/Other - Health & Safety.png";
import otherDashboards from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/other/Other - Dashboard.png";

import healthcareBreakroomEmployeeReg from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/healthcare/Healthcare - Breakroom Employee Reg.png";
import healthcareBreakroomStaffUpdates from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/healthcare/Healthcare - Breakroom Staff Updates.png";
import healthcareHealthEducation from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/healthcare/Healthcare - Health Education.png";
import healthcarePatientEngagement from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/healthcare/Healthcare - Patient Engagement.png";
import healthcareWayfinding from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/healthcare/Healthcare - Wayfinding.png";

import realEstateBrandingAndMarketing from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/realEstate/Real Estate - Branding and Marketing.png";
import realEstateEventPromotion from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/realEstate/Real Estate - Event Promotion.png";
import realEstatePropertyListingsAndAvailableSpaces from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/realEstate/Real Estate - Property Listings and Available Spaces.png";

import transportationCustomerCommunicationAndAlerts from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/logistic/Logistics - Customer Communication and Alerts.png";
import transportationEmergencyAlerts from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/logistic/Logistics - Emergency Alerts.png";
import transportationEmployeeBenefits from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/logistic/Logistics - Employee Benefits.png";
import transportationEmployeeRecognition from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/logistic/Logistics - Employee Recognition.png";
import transportationHealthAndSafety from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/logistic/Logistics - Health and Safety.png";
import transportationShiftScheduling from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/logistic/Logistics - Shift Scheduling.png";

import financeDashboards from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/finance/Dashboards.png";
import financeCorporateBrandingAndCulture from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/finance/Finance and offices - Corporate Branding and Culture.png";
import financeEmployeeRecognition from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/finance/Finance and offices - Employee Recognition.png";
import financeInternalCommunication from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/finance/Finance and offices - Internal Communication.png";
import financeMeetingRoomAvailability from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/finance/Finance and offices - Meeting Room Availability.png";
import financeWelcome from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/finance/Finance and offices - welcome.png";

import energyEnvironmentalAwareness from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/energy/Energy - Environmental Awareness.jpg";
import energyHealthAndSafety from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/energy/Energy - Health and Safety.jpg";
import energyWelcomeDisplays from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/energy/Energy - Welcome Displays.jpg";
import energyWorkSchedules from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/energy/Energy - Work Schedules.png";
import energyDashboards from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/energy/Dashboards.png";

import fitnessAd from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/fitness/Fitness - Ad.png";
import fitnessHealthyGuides from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/fitness/Fitness - Healthy Guides.png";
import fitnessHighlight from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/fitness/Fitness - Highlight.png";
import fitnessUpcomingEvents from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/fitness/Fitness - Upcoming Events.png";
import fitnessWayfinding from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/fitness/Fitness - Wayfinding.png";

import worshipEventPromotionAndReminders from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/placeOfWorship/Worship - Event Promotion and Reminders.jpg";
import worshipLyricsAndScriptures from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/placeOfWorship/Worship - Lyrics and Scriptures.png";
import worshipPrayerRequests from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/placeOfWorship/Worship - Prayer Requests.png";
import worshipServiceSchedule from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/placeOfWorship/Worship - Service Schedule.png";
import worshipWelcome from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/placeOfWorship/Worship - Welcome.png";

import eventManagementAdvertisingAndSponsorships from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/event/Event Management - Advertising and Sponsorships.png";
import eventManagementAnnouncementsAndAlerts from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/event/Event Management - Announcements and Alerts.png";
import eventManagementEventSchedules from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/event/Event Management - Event Schedules.png";
import eventManagementHighlights from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/event/Event Management - Highlights.png";
import eventManagementWayfinding from "src/pages/Welcome/images/designYourContent/canvasPlaceholdersByIndustry/event/Event Management - Wayfinding.png";

export const placeholderTemplateByIndustry = {
  [Industries.Education]: {
    "Education - Emergency Alerts": emergencyAlerts,
    "Education - Employee Recognition": employeeRecognition,
    "Education - Event promotion": eventPromotion,
    "Education - Wayfinding": wayfinding,
    "Education - Menu": menu,
  },
  [Industries.HospitalityFoodBeverage]: {
    "Hospitality - Menu": hospitalityMenu,
    "Hospitality - Event Promotion": hospitalityEventPromotion,
    "Hospitality - Self Check-in": hospitalitySelfCheckIn,
    "Hospitality - Way Finding": hospitalityWayfinding,
  },
  [Industries.Manufacturing]: {
    "Manufacturing - Emergency Alert": manufacturingEmergencyAlerts,
    "Manufacturing - Employee Benefits": manufacturingBenefits,
    "Manufacturing - Employee Recognition": manufacturingEmployeeRecognition,
    "Manufacturing - Employee Training": manufacturingEmployeeTraining,
    "Manufacturing - Event Benifits": manufacturingEventBenefits,
    "Health & Safety": manufacturingHealthAndSafety,
  },
  [Industries.SoftwareAndService]: {
    "Technology & B2B -  Meeting Room Availability":
      technologyMeetingRoomAvailability,
    "Technology & B2B -  welcome": technologyWelcome,
    "Technology & B2B - Corporate Branding and Culture":
      technologyCorporateBrandingAndCulture,
    "Technology & B2B - Employee Recognition": technologyEmployeeRecognition,
    "Technology & B2B - Internal Comms": technologyInternalComms,
  },
  [Industries.Retail]: {
    "Retail - Ad": retailAd,
    "Retail - Employee Benefits": retailEmployeeBenefits,
    "Retail - Employee Engagement": retailEmployeeEngagement,
    "Retail - Event": retailEvent,
    "Retail - Health and Safety": retailHealthAndSafety,
    "Retail - Shift Scheduling": retailShiftScheduling,
  },
  [Industries.Other]: {
    "Other - Advertisement": otherAd,
    Dashboard: otherDashboards,
    "Other - Employee Recognition": otherEmployeeRecognition,
    "Other - Event Announcement": otherEventAnnouncement,
    "Other - Health and Safety": otherHealthAndSafety,
    "Other - Welcome Message": otherWelcome,
  },
  [Industries.Healthcare]: {
    "Healthcare - Breakroom Employee Reg": healthcareBreakroomEmployeeReg,
    "Healthcare - Breakroom Staff Updates": healthcareBreakroomStaffUpdates,
    "Healthcare - Health Education": healthcareHealthEducation,
    "Healthcare - Patient Engagement": healthcarePatientEngagement,
    "Healthcare - Wayfinding": healthcareWayfinding,
  },
  [Industries.RealEstate]: {
    "Real Estate - Branding and Marketing": realEstateBrandingAndMarketing,
    "Real Estate - Event Promotion": realEstateEventPromotion,
    "Real Estate - Property Listings and Available Spaces":
      realEstatePropertyListingsAndAvailableSpaces,
  },
  [Industries.Transportation]: {
    "Logistics - Customer Communication and Alerts":
      transportationCustomerCommunicationAndAlerts,
    "Logistics - Emergency Alerts": transportationEmergencyAlerts,
    "Logistics - Employee Benefits": transportationEmployeeBenefits,
    "Logistics - Employee Recognition": transportationEmployeeRecognition,
    "Logistics - Health and Safety": transportationHealthAndSafety,
    "Logistics - Shift Scheduling": transportationShiftScheduling,
  },
  [Industries.Finance]: {
    "Finance and offices - welcome": financeWelcome,
    "Finance and offices - Corporate Branding and Culture":
      financeCorporateBrandingAndCulture,
    "Finance and offices - Employee Recognition": financeEmployeeRecognition,
    "Finance and offices - Internal Communication":
      financeInternalCommunication,
    "Finance and offices - Meeting Room Availability":
      financeMeetingRoomAvailability,
    Dashboards: financeDashboards,
  },
  [Industries.Energy]: {
    "Energy - Environmental Awareness": energyEnvironmentalAwareness,
    "Energy - Health and Safety": energyHealthAndSafety,
    "Energy - Welcome Displays": energyWelcomeDisplays,
    "Energy - Work Schedules": energyWorkSchedules,
    Dashboards: energyDashboards,
  },
  [Industries.Fitness]: {
    "Fitness - Ad": fitnessAd,
    "Fitness - Healthy Guides": fitnessHealthyGuides,
    "Fitness - Highlight": fitnessHighlight,
    "Fitness - Upcoming Events": fitnessUpcomingEvents,
    "Fitness - Wayfinding": fitnessWayfinding,
  },
  // Industry not supported yet
  // [Industries.HospitalityFoodBeverage]: {
  //   "Food & Beverages - Advertisement": xxx,
  //   "Food & Beverages - Event Highlights and Announcements": xxx,
  //   "Food & Beverages - Menu": xxx,
  //   "Food & Beverages - Promotions and Deals": xxx,
  // },
  [Industries.PlacesOfWorship]: {
    "Worship - Event Promotion and Reminders":
      worshipEventPromotionAndReminders,
    "Worship - Lyrics and Scriptures": worshipLyricsAndScriptures,
    "Worship - Prayer Requests": worshipPrayerRequests,
    "Worship - Service Schedule": worshipServiceSchedule,
    "Worship - Welcome": worshipWelcome,
  },
  // Industry not supported yet
  // [Industries.Government]: {
  //   "Gov - Educational": governmentEducational,
  //   "Gov - Employee Training": governmentEmployeeTraining,
  //   "Gov - Health Safety": governmentHealthSafety,
  //   "Gov - Upcoming Event": governmentUpcomingEvent,
  //   "Gov - Wayfinding": governmentWayfinding,
  // },
  [Industries.Events]: {
    "Event Management - Advertising and Sponsorships":
      eventManagementAdvertisingAndSponsorships,
    "Event Management - Announcements and Alerts":
      eventManagementAnnouncementsAndAlerts,
    "Event Management - Event Schedules": eventManagementEventSchedules,
    "Event Management - Highlights": eventManagementHighlights,
    "Event Management - Wayfinding": eventManagementWayfinding,
  },
};

export const tickerConsts = [
  "Display news messages here",
  "You could even post the weather here",
  "Display news messages here",
  "You could even post the weather here",
  "Display news messages here",
  "You could even post the weather here",
  "Display news messages here",
];
